(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-accesorii-menu"] && !Shopify.designMode) return;
  try {
    function positionAccessoryPanels() {
    document.querySelectorAll('.td-accesorii-submenu').forEach((panel) => {
      const anchor = panel.offsetParent;
      if (!anchor) return;
      const width = Math.min(1480, document.documentElement.clientWidth - 48);
      const left = (document.documentElement.clientWidth - width) / 2 - anchor.getBoundingClientRect().left;
      panel.style.setProperty('--td-panel-left', `${left}px`);
    });
  }
  positionAccessoryPanels();
  window.addEventListener('resize', positionAccessoryPanels, { passive: true });
  document.addEventListener('shopify:section:load', positionAccessoryPanels);
  document.addEventListener('DOMContentLoaded', positionAccessoryPanels, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-connectica-menu"] && !Shopify.designMode) return;
  try {
    function positionConnectivityPanels() {
    document.querySelectorAll('.td-connectica-submenu').forEach((panel) => {
      const anchor = panel.offsetParent;
      if (!anchor) return;
      const width = Math.min(1480, document.documentElement.clientWidth - 48);
      const left = (document.documentElement.clientWidth - width) / 2 - anchor.getBoundingClientRect().left;
      panel.style.setProperty('--td-panel-left', `${left}px`);
    });
  }
  positionConnectivityPanels();
  window.addEventListener('resize', positionConnectivityPanels, { passive: true });
  document.addEventListener('shopify:section:load', positionConnectivityPanels);
  document.addEventListener('DOMContentLoaded', positionConnectivityPanels, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-folii-menu"] && !Shopify.designMode) return;
  try {
    function positionFilmPanels() {
    document.querySelectorAll('.td-folii-submenu').forEach((panel) => {
      const anchor = panel.offsetParent;
      if (!anchor) return;
      const viewportWidth = document.documentElement.clientWidth;
      const width = Math.min(1480, viewportWidth - 48);
      const left = (viewportWidth - width) / 2 - anchor.getBoundingClientRect().left;
      panel.style.setProperty('--td-panel-left', `${left}px`);
    });
  }
  positionFilmPanels();
  window.addEventListener('resize', positionFilmPanels, { passive: true });
  document.addEventListener('shopify:section:load', positionFilmPanels);
  document.addEventListener('DOMContentLoaded', positionFilmPanels, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-huse-menu"] && !Shopify.designMode) return;
  try {
    function positionCasePanels() {
    document.querySelectorAll('.td-huse-submenu').forEach((panel) => {
      const anchor = panel.offsetParent;
      if (!anchor) return;
      const width = Math.min(1480, document.documentElement.clientWidth - 48);
      const left = (document.documentElement.clientWidth - width) / 2 - anchor.getBoundingClientRect().left;
      panel.style.setProperty('--td-panel-left', `${left}px`);
    });
  }
  positionCasePanels();
  window.addEventListener('resize', positionCasePanels, { passive: true });
  document.addEventListener('shopify:section:load', positionCasePanels);
  document.addEventListener('DOMContentLoaded', positionCasePanels, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-mobile-category-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.td-mobile-category-menu')) return;
    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', String(details.open));
  }, true);
  } catch(e) { console.error(e); }
})();

})();
